import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { apiClient } from '../client';
import { queryKeys } from '../react-query.config';

export const useUserDetails = () => {
  const { isAuthenticated, isLoading: authLoading } = useAuth();

  return useQuery({
    queryKey: queryKeys.user.details(),
    queryFn: async () => {
      return apiClient.get('/api/auth/user-details');
    },
    enabled: isAuthenticated && !authLoading,
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 2,
  });
};
